import { BehaviorSubject } from 'rxjs';
import jwt from 'jwt-decode';
import { getState, dispatch } from '../state/store';
import { selectAppUser, selectIsReady } from '../state/selectors/app';
import { clearState, setAppSettings, setAppUser } from '../state/ducks/app';

const CURRENT_USER = 'currentUser';
const USER_ID_HEADER = "http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata";
// const currentUserSubject = new BehaviorSubject(JSON.parse(sessionStorage.getItem(CURRENT_USER)));
//const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem(CURRENT_USER)));



const getCurrentUser = () => {
    const stateUser = selectAppUser()(getState());
    if(stateUser) return stateUser;

    const sessionUser = JSON.parse(sessionStorage.getItem(CURRENT_USER));
    if(sessionUser){
        dispatch(setAppUser(sessionUser));
        return sessionUser;
    }

    return null;
}

async function login(userName, password) {
    const loginData = {
        userName: userName,
        password: password
    };
    const requestParams = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData)
    };

    const request = new Request('/api/authentication/token', requestParams);
    let response = await fetch(request);

    const data = await response.json();

    if (!response.ok) {
        if ([401, 403].indexOf(response.status) != -1) {
            logout();
            //location.reload(true);
        }

        const error = (data && data.ErrorCode) || response.statusText;
        throw new Error(error);
    }

    const parsed = jwt(data.token);

    let user = {
        token: data.token,
        userName: data.userName,
        userId: parsed[USER_ID_HEADER]
    }
    sessionStorage.setItem(CURRENT_USER, JSON.stringify(user));
    //localStorage.setItem(CURRENT_USER, JSON.stringify(user));
    dispatch(setAppUser(user));
    // currentUserSubject.next(data);
}


function logout() {
    //localStorage.removeItem(CURRENT_USER);
    sessionStorage.removeItem(CURRENT_USER);
    // currentUserSubject.next(null);
    dispatch(setAppUser(null));
    dispatch(clearState());
}


export const authenticationService = {
    login,
    logout,
    getCurrentUser
}